import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=9d81b21e&scoped=true&"
import script from "./InformationPage.vue?vue&type=script&lang=js&"
export * from "./InformationPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationPage.vue?vue&type=style&index=0&id=9d81b21e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d81b21e",
  null
  
)

export default component.exports